import _slicedToArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { jsx as e } from "react/jsx-runtime";
import { createContext as t, useContext as n, useRef as i, useState as r } from "react";
import { config as s, useTransition as o, animated as a } from "react-spring";
import { useDrag as l } from "@use-gesture/react";
import { a as d, b as c, c as u } from "./useThumbsModule-0944decf.js";
import "rxjs";
import "screenfull";
var m = t(void 0);

function g() {
  var e = n(m);
  if (!e) throw new Error("useTransitionCarouselContext isn't being used within the useTransitionCarousel context; \n    use the context only inside a component that is rendered within the Carousel.");
  return e;
}

function h(_ref) {
  var t = _ref.items,
      _ref$withLoop = _ref.withLoop,
      n = _ref$withLoop === void 0 ? !1 : _ref$withLoop,
      _ref$withThumbs = _ref.withThumbs,
      g = _ref$withThumbs === void 0 ? !1 : _ref$withThumbs,
      _ref$springConfig = _ref.springConfig,
      h = _ref$springConfig === void 0 ? s.default : _ref$springConfig,
      _ref$thumbsSlideAxis = _ref.thumbsSlideAxis,
      p = _ref$thumbsSlideAxis === void 0 ? "x" : _ref$thumbsSlideAxis,
      _ref$enableThumbsWrap = _ref.enableThumbsWrapperScroll,
      f = _ref$enableThumbsWrap === void 0 ? !0 : _ref$enableThumbsWrap,
      _ref$draggingSlideTre = _ref.draggingSlideTreshold,
      b = _ref$draggingSlideTre === void 0 ? 50 : _ref$draggingSlideTre,
      x = _ref.prepareThumbsData,
      v = _ref.toPrevItemSpringProps,
      I = _ref.toNextItemSpringProps,
      _ref$disableGestures = _ref.disableGestures,
      T = _ref$disableGestures === void 0 ? !1 : _ref$disableGestures,
      S = _ref.trail,
      _ref$exitBeforeEnter = _ref.exitBeforeEnter,
      j = _ref$exitBeforeEnter === void 0 ? !1 : _ref$exitBeforeEnter,
      _ref$springAnimationP = _ref.springAnimationProps,
      O = _ref$springAnimationP === void 0 ? {
    initial: {
      opacity: 1,
      position: "absolute"
    },
    from: {
      opacity: 0,
      position: "absolute"
    },
    enter: {
      opacity: 1,
      position: "absolute"
    },
    leave: {
      opacity: 0,
      position: "absolute"
    }
  } : _ref$springAnimationP;

  var y = i("next"),
      C = i(null),
      w = i(!1),
      _r = r(0),
      _r2 = _slicedToArray(_r, 2),
      A = _r2[0],
      N = _r2[1],
      _d = d(),
      F = _d.emitObservable,
      P = _d.useListenToCustomEvent,
      _c = c({
    emitObservable: F,
    mainCarouselWrapperRef: C
  }),
      E = _c.enterFullscreen,
      L = _c.exitFullscreen,
      R = _c.getIsFullscreen,
      _u = u({
    items: t,
    withThumbs: g,
    thumbsSlideAxis: p,
    springConfig: h,
    prepareThumbsData: x,
    slideType: "fixed"
  }),
      B = _u.thumbsFragment,
      D = _u.handleThumbsScroll,
      W = l(function (_ref2) {
    var e = _ref2.last,
        _ref2$movement = _slicedToArray(_ref2.movement, 1),
        i = _ref2$movement[0];

    if (!G() && e) {
      var _e = i > b,
          _r3 = i < -b,
          _s = 0 === A,
          _o = A === t.length - 1;

      if (_r3) {
        if (!n && _o) return;
        H(), F({
          eventName: "onLeftSwipe"
        });
      } else if (_e) {
        if (!n && _s) return;
        J(), F({
          eventName: "onRightSwipe"
        });
      }
    }
  }, {
    enabled: !T
  });

  var k = o(A, Object.assign(Object.assign({
    config: h
  }, function () {
    var e = z();
    return "prev" === e && v ? {
      initial: Object.assign({}, O.initial),
      from: Object.assign({}, v.from),
      enter: Object.assign({}, v.enter),
      leave: Object.assign({}, v.leave)
    } : "next" === e && I ? {
      initial: Object.assign({}, O.initial),
      from: Object.assign({}, I.from),
      enter: Object.assign({}, I.enter),
      leave: Object.assign({}, I.leave)
    } : {
      initial: Object.assign({}, O.initial),
      from: Object.assign({}, O.from),
      enter: Object.assign({}, O.enter),
      leave: Object.assign({}, O.leave)
    };
  }()), {
    onStart: function onStart() {
      return M(!0);
    },
    trail: S,
    exitBeforeEnter: j,
    key: t[A].id,
    onRest: function onRest(e) {
      e.finished && (M(!1), F({
        eventName: "onSlideChange",
        slideActionType: z(),
        currentItem: {
          index: A,
          id: t[A].id
        }
      }));
    }
  }))(function (n, i) {
    return e(a.div, Object.assign({
      style: Object.assign(Object.assign({}, n), {
        flex: "1 0 100%",
        width: "100%",
        height: "100%"
      })
    }, {
      children: t[i].renderItem
    }));
  });

  function G() {
    return w.current;
  }

  function M(e) {
    w.current = e;
  }

  function q(e) {
    y.current = e;
  }

  function z() {
    return y.current;
  }

  function H() {
    var e = A === t.length - 1;
    n ? (q("next"), e ? (F({
      eventName: "onSlideStartChange",
      slideActionType: z(),
      nextItem: {
        index: 0,
        id: t[0].id
      }
    }), N(0)) : (F({
      eventName: "onSlideStartChange",
      slideActionType: z(),
      nextItem: {
        index: A + 1,
        id: t[A + 1].id
      }
    }), N(A + 1))) : e || (F({
      eventName: "onSlideStartChange",
      slideActionType: z(),
      nextItem: {
        index: A + 1,
        id: t[A + 1].id
      }
    }), q("next"), N(A + 1));
  }

  function J() {
    var e = 0 === A;
    n ? (q("prev"), e ? (F({
      eventName: "onSlideStartChange",
      slideActionType: z(),
      nextItem: {
        index: t.length - 1,
        id: t[t.length - 1].id
      }
    }), N(t.length - 1)) : (F({
      eventName: "onSlideStartChange",
      slideActionType: z(),
      nextItem: {
        index: A - 1,
        id: t[A - 1].id
      }
    }), N(A - 1))) : e || (q("prev"), F({
      eventName: "onSlideStartChange",
      slideActionType: z(),
      nextItem: {
        index: A - 1,
        id: t[A - 1].id
      }
    }), N(A - 1));
  }

  function K(e) {
    return t.findIndex(function (t) {
      return t.id === e;
    });
  }

  var Q = {
    activeItem: A,
    slideToItem: function slideToItem(e) {
      var n = 0;
      if (n = "string" == typeof e ? t.findIndex(function (t) {
        return t.id === e;
      }) : e, n >= t.length) throw Error("The item you want to slide to doesn't exist. This could be due to the fact that \n        you provide a wrong id or a higher numeric index.");
      if (n === A) return;
      var i = K(t[A].id),
          r = K(t[n].id);
      F({
        eventName: "onSlideStartChange",
        slideActionType: z(),
        nextItem: {
          index: r,
          id: t[n].id
        }
      }), q(r > i ? "next" : "prev"), N(n), f && g && D(n);
    },
    slideToNextItem: H,
    slideToPrevItem: J,
    enterFullscreen: E,
    exitFullscreen: L,
    useListenToCustomEvent: P,
    getIsNextItem: function getIsNextItem(e) {
      var i = K(e);
      return n && A === t.length - 1 ? 0 === i : i === A + 1;
    },
    getIsPrevItem: function getIsPrevItem(e) {
      var i = K(e);
      return n && 0 === A ? i === t.length - 1 : i === A - 1;
    },
    getIsAnimating: G,
    getIsFullscreen: R,
    getIsActiveItem: function getIsActiveItem(e) {
      return K(e) === A;
    },
    getCurrentActiveItem: function getCurrentActiveItem() {
      return {
        id: t[A].id,
        index: A
      };
    }
  },
      U = e(m.Provider, Object.assign({
    value: Q
  }, {
    children: e("div", Object.assign({
      ref: C
    }, W(), {
      style: {
        display: "flex",
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden"
      }
    }, {
      children: k
    }))
  })),
      V = e(m.Provider, Object.assign({
    value: Q
  }, {
    children: B
  }));
  return Object.assign({
    carouselFragment: U,
    thumbsFragment: V
  }, Q);
}

export { h as useTransitionCarousel, g as useTransitionCarouselContext };